import type { WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = () =>
  createStyles({
    container: {},
    textfield: {
      paddingTop: 32,
      "& > *": {
        textAlign: "left",
      },
    },
    linkButton: {
      paddingLeft: 0,
      marginTop: 32,
      float: "left",
    },
    verifyButton: {
      marginTop: 32,
      width: "100%",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
